import { useState } from 'react'

import { Box, SelectOptionGroups, Spinner } from '@factorialco/deprecated-design-system'

import Select from 'modules/core/components/Select'
import { useEffect, useUnsafeEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { useActionWizard } from 'modules/processes/components/ItemWizard/Actions/ActionProvider'
import { ActionConfigurationHeader } from 'modules/processes/components/ItemWizard/Actions/Steps/FillInformation/Header'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'
import Form from 'modules/processes/components/ItemWizard/components/Form'
import Assignees from 'modules/processes/components/ItemWizard/components/Form/Items/Assignees'
import Title from 'modules/processes/components/ItemWizard/components/Form/Items/Title'
import surveys from 'modules/surveys/store/collections/v2/surveys'
import { Status } from 'modules/surveys/store/models/v2/Survey'

import { NoSurveyBox } from './components/NoSurveyBox'

interface StateProps {
  survey_id: string | undefined
}

const initialState = {
  survey_id: undefined,
}

export const Editor = () => {
  const [state, setState] = useState<StateProps>(initialState)
  const [surveyOptions, setSurveyOptions] = useState<SelectOptionGroups>([])
  const [loading, setLoading] = useState<boolean>(true)
  const { setPreviewValues } = usePreviewProvider()

  const { updateConfiguration, getInitialConfiguration } = useActionWizard()

  const fetchSurveyOptions = () => {
    surveys
      .fetch({
        data: {
          source: 'workflow_survey',
          status: Status.active,
        },
      })
      .then(() => {
        setSurveyOptions(
          surveys.models
            .filter((survey) => survey.isActive)
            .map((survey) => {
              return { label: survey.get('name'), value: survey.get('id') }
            })
        )

        setLoading(false)
      })
  }

  useUnsafeEffect(() => {
    const newState = getInitialConfiguration<StateProps>(initialState)
    setState(newState)
  }, [getInitialConfiguration])

  useEffect(() => {
    fetchSurveyOptions()
  }, [])

  useUnsafeEffect(() => {
    if (state.survey_id !== undefined && surveyOptions.length) {
      updateConfiguration({ survey_id: state.survey_id })

      const currentSurvey = surveys.models.find((survey) => survey.get('id') === state.survey_id)

      setPreviewValues({
        survey: currentSurvey,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, surveyOptions])

  const surveySelector = (
    <Select
      none={
        surveyOptions.length
          ? i18n.t('common.none')
          : i18n.t('processes.process_settings.actions.survey_action.empty_surveys.no_survey')
      }
      label={i18n.t('processes.process_settings.actions.survey_action.select')}
      options={surveyOptions}
      value={state.survey_id}
      onChange={(value) => setState({ survey_id: String(value) })}
    />
  )

  return (
    <>
      <ActionConfigurationHeader
        description={i18n.t('processes.process_settings.actions.action_description')}
      />

      <Box paddingY="s16" justifyContent="center" alignItems="center" width="full">
        <Box gap="s24" width="full" overflowX="hidden">
          {loading ? (
            <Spinner />
          ) : (
            <Form
              items={{
                ...(!surveyOptions.length && { noSurveyBox: <NoSurveyBox /> }),
                title: <Title />,
                selector: surveySelector,
                assignees: (
                  <Assignees
                    label={i18n.t('processes.process_settings.actions.automatic_email.recipient')}
                    onlyForAffectedUser
                    readonly
                  />
                ),
              }}
            ></Form>
          )}
        </Box>
      </Box>
    </>
  )
}
